import { render, staticRenderFns } from "./PaddockFinder.vue?vue&type=template&id=4c254944"
import script from "./PaddockFinder.vue?vue&type=script&lang=js"
export * from "./PaddockFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputSearch: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/input/templates/search/InputSearch.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default,Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default})
